"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModeStateConfigSchema = exports.IModeStateDefinitionSchema = void 0;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("../BoundaryLevel");
const ModeStateType_1 = require("./ModeStateType");
exports.IModeStateDefinitionSchema = zod_1.z.object({
    stateId: zod_1.z.nativeEnum(ModeStateType_1.ModeStateType),
    isNominalState: zod_1.z.boolean().optional(),
    unreachableSeverity: BoundaryLevel_1.BoundaryLevelSchema.optional(),
});
exports.IModeStateConfigSchema = zod_1.z.object({
    states: exports.IModeStateDefinitionSchema.array().refine((states) => states.filter((state) => state.isNominalState === true).length <= 1, { message: 'At most one mode state may set isNominalState' }),
});
//# sourceMappingURL=IModeStateConfig.js.map